import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../services/api";

export default function VerifyCard() {
  const { beneficiaryId } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/beneficiary/verify/${beneficiaryId}`)
      .then(res => setData(res.data))
      .catch(() => setData({ valid: false, status: "NOT FOUND" }));
  }, [beneficiaryId]);

  if (!data) return <h2>Checking card...</h2>;

  return (
    <div style={{ padding: 30, textAlign: "center" }}>
      <h1>{data.valid ? "✅ VALID CARD" : "❌ INVALID CARD"}</h1>
      <h2>{data.name}</h2>
      <p><b>Beneficiary ID:</b> {data.beneficiaryId}</p>
      <p><b>Status:</b> {data.status}</p>
      <p><b>Valid Till:</b> {data.validTill}</p>
    </div>
  );
}